export default __webpack_public_path__ + "static/media/aerolab-logo.40b78ac9.svg";